export default __webpack_public_path__ + "static/BT_Benefits_Carousel_09-9ba69299ca418d9fb40a2d6e063fa45d.jpg";